var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"max-width":"800px"}},[_c('v-card',{staticClass:"ma-4",attrs:{"elevation":"5"}},[_c('v-card-title',{staticClass:"custom-card-subtitle"},[_vm._v(" アンケートの回答を受け付けました ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }